import { Directive, ElementRef, Inject } from '@angular/core'

@Directive({
  selector: '[focus-element]',
  standalone: false,
})
export class FocusElementDirective {
  constructor(@Inject(ElementRef) private hostElement: ElementRef) {}

  ngOnInit() {
    this.hostElement.nativeElement.focus()
  }
}
